import { useQueryClient } from "@tanstack/react-query";

// Refetches the notification queries (count + list + popup) so the bell badge
// updates immediately instead of on the next poll.
export const useInvalidateNotifications = () => {
  const queryClient = useQueryClient();

  return () => {
    void queryClient.invalidateQueries({ queryKey: ["notifications"] });
  };
};
